<template>
  <el-dialog
    :visible.sync="disableDialog"
    :before-close="clodeDialog"
    class="dialog-address"
    width="465px"
    title="添加账户"
  >
    <el-form
      label-width="90px"
      ref="closeformex"
      :model="params"
      style="padding:0 30px"
    >
      <el-form-item prop="suName" label="账户名称：">{{params.suName}}</el-form-item>
      <el-form-item
        label="银行账号："
        prop="bankCode"
        :rules="filter_rules({required:true})"
      >
        <el-input v-model.trim="params.bankCode"></el-input>
      </el-form-item>
      <el-form-item
        label="开户行："
        prop="bankOpencount"
        :rules="filter_rules({required:true})"
      >
        <el-input v-model.trim="params.bankOpencount"></el-input>
      </el-form-item>
      <el-form-item
        label="银行行号："
        prop="bankOpenCode"
      >
        <el-input v-model.trim="params.bankOpenCode"></el-input>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-center"
    >
      <el-button
        @click="onSubmit"
        type="primary"
      >确定</el-button>
      <el-button @click="disableDialog=false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { supplierBankAdd } from '@/api/purchase/purchasePlanList'
import { customerBankUpdate } from '@/api/sell/sellManage'
import { deepClone } from '@/util'

export default {
  data () {
    return {
      params: {},
      disableDialog: false
    }
  },
  methods: {
    // 添加收货人初始化
    onInitial (val) {
      this.params = val || {}
      this.disableDialog = true
    },
    clodeDialog(done) {
      done()
    },
    // 确定
    onSubmit () {
      if (!this.params.bankCode) {
        this.$message.error('银行账号不可为空！')
        return
      }
      if (!this.params.bankOpencount) {
        this.$message.error('开户行不可为空！')
        return
      }

      if (this.params.isChange === 85) {
        const obj = {
          flag: true,
          bankCode: this.params.bankOpenCode,
          bankAccount: this.params.bankCode,
          cusId: this.params.cusId,
          bankOpencount: this.params.bankOpencount
        }
        customerBankUpdate([obj])
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success(res.data.msg)
              this.disableDialog = false
              this.$nextTick(() => {
                this.$refs.closeformex.resetFields()
              })
              this.$emit('addAccountDialog', obj, res.data.obj)
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        supplierBankAdd(this.params)
          .then((res) => {
            if (res.data.code === 200) {
              // this.$refs.closeformex.resetFields()
              this.disableDialog = false
              this.$nextTick(() => {
                this.$refs.closeformex.resetFields()
              })
              this.$message.success(res.data.msg)
              this.$emit('addAccountDialog')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
}
</script>
